
<script lang="ts">
  import { onMount, SvelteComponent } from 'svelte';
  import type { CustomComponent } from "../custom-component";
  import { getStoresContext, type StoresKey } from '~/stores';

  type ConsentCategory = 'preferences' | 'marketing' | 'statistics';
  type Cookiebot = {
    hasResponse: boolean;
    consented: boolean;
    declined: boolean;
    doNotTrack: boolean;
    consent: {
      preferences: boolean;
      statistics: boolean;
      marketing: boolean;
      method: string;
    }
    show: () => void;
    hide: () => void;
  };

  export let consent_category: ConsentCategory;
  export let request_store_key: StoresKey;
  export let submit_button: CustomComponent<SvelteComponent> | undefined = undefined;
  export let submit_button_class: string = '';


  const { T } = getStoresContext(request_store_key);

  $: t = $T;
  $: reason = t`cookiebot.content_blocked`
    .replace('%s', t`cookiebot.${consent_category}`);
  

  let cookiebot: Cookiebot;
  let showContent: boolean = false;

  onMount(() => {
    initializeCookiebot();
  });

  function initializeCookiebot() {
    cookiebot = (window as any).Cookiebot;
    showContent = !cookiebot // No Cookiebot -> do not block
      || (cookiebot?.hasResponse 
        && cookiebot?.consented 
        && cookiebot?.consent[consent_category]);
  }

  function openCookiebotBanner() {
    cookiebot.show();
  }
</script>
  

<svelte:window on:CookiebotOnConsentReady={initializeCookiebot} />
<div>
  {#if showContent}
    <slot />
  {:else if cookiebot}
    <div class="block-consent-div">
      <p>{reason}</p>
      {#if submit_button}
        <svelte:component 
          this={submit_button?.component} 
          {...submit_button?.props}
          on:click={openCookiebotBanner}
        >
          {t`cookiebot.change_consent`}
        </svelte:component>
      {:else}
        <button class={submit_button_class} 
          on:click={openCookiebotBanner}
          >
          {t`cookiebot.change_consent`}
        </button>
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  .block-consent-div {
    background-color: var(--brand-color-2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
  }
</style>
